import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ApiError } from '@data-access/api/error';
import { UISnackbarService } from '@ui/components';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from '../services/auth/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly authService: AuthService = inject(AuthService);
  private readonly snackbar: UISnackbarService = inject(UISnackbarService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return this.authService.getToken$().pipe(
      switchMap((token: string | null) => {
        const authorizedRequest: HttpRequest<unknown> = token
          ? request.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
          : request;
        return next.handle(authorizedRequest).pipe(
          catchError((err: ApiError) => {
            const is401: boolean = err.originalError instanceof HttpErrorResponse && err.originalError.status == 401;
            if (!is401 || this.authService.isLoginPending()) {
              return throwError(() => err);
            }
            this.logoutAfterUnauthorized(err);
            return throwError(() => err);
          }),
        );
      }),
    );
  }

  private logoutAfterUnauthorized(err: ApiError): void {
    const isLockedOut: boolean = err.originalError?.error?.detail === 'error.user.lockedOut';
    if (!isLockedOut && this.authService.isLoggedIn()) {
      this.snackbar.showNeutral('Your session has expired, please log in again');
    }
    this.authService.logout();
  }
}
